import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     13/11/2017
// Description: Welcome View. Displays basic branding and opportunity to log in.
////-------------------------------------------------------------------------------------------

@Component({
  selector: 'app-portal-welcome-view',
  templateUrl: './portal-welcome-view.component.html',
  styleUrls: ['./portal-welcome-view.component.css']
})
export class PortalWelcomeViewComponent implements OnInit {

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router) { }

  ngOnInit() {
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, "Welcome", null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, false, false, true));
  }

  login() {
    this.router.navigate(['app/login']);
  } 

}



// WEBPACK FOOTER //
// ./src/app/views/portal-welcome-view/portal-welcome-view.component.ts